import { render, staticRenderFns } from "./landing-modal2.vue?vue&type=template&id=08fae334"
import script from "./landing-modal2.vue?vue&type=script&lang=ts"
export * from "./landing-modal2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08fae334')) {
      api.createRecord('08fae334', component.options)
    } else {
      api.reload('08fae334', component.options)
    }
    module.hot.accept("./landing-modal2.vue?vue&type=template&id=08fae334", function () {
      api.rerender('08fae334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/landing-modal2.vue"
export default component.exports